import { writable } from 'svelte/store';

/**
 * L'id dell'utente autenticato (SuperTokens), o `null` senza sessione.
 *
 * Tenuto da stores/auth.js. Vive in un modulo a parte, senza dipendenze, per
 * una ragione sola: ciò che il server dice di un account (le capacità e le
 * funzioni che ha) vale per quell'account, e chi le tiene in memoria deve
 * poter sapere quando l'account cambia — anche sulla stessa azienda — senza
 * importare l'intero modulo di autenticazione.
 */
export const sessionUserId = writable(null);
